import {
  AuthorizationList,
  useProductAuthorizations,
} from '@increasecard/increase-core';
import { PayAuthorizations } from './PayAuthorizations';
import config from '../../config';

export { PayAuthorizations } from './PayAuthorizations';

type AuthorizationCallbacks = {
  [K in keyof typeof PayAuthorizations as `can${Capitalize<K & string>}`]: () => boolean;
};

export function usePayAuthorizations(): AuthorizationCallbacks & {
  userCan: (authorizations: AuthorizationList) => boolean;
} {
  const { userHasAuthorization } = useProductAuthorizations();
  const userCan = (authorizations: AuthorizationList) => {
    // see if authorizations must be checked
    if (config.useAuthorizations === false) {
      // bypass authorizations
      return true;
    }
    // check if user has at least one authorization of the list
    return authorizations.some((action: string) => {
      return userHasAuthorization(action);
    });
  };
  const callbacks = {} as AuthorizationCallbacks;
  for (const [key, auth] of Object.entries(PayAuthorizations)) {
    const canKey =
      `can${key.charAt(0).toUpperCase()}${key.slice(1)}` as keyof AuthorizationCallbacks;
    callbacks[canKey] = () => userCan(auth);
  }
  return { userCan, ...callbacks };
}
